import { render, staticRenderFns } from "./BackendDeliverySingle.vue?vue&type=template&id=4984819a&scoped=true&lang=pug"
import script from "./BackendDeliverySingle.vue?vue&type=script&lang=js"
export * from "./BackendDeliverySingle.vue?vue&type=script&lang=js"
import style0 from "./BackendDeliverySingle.vue?vue&type=style&index=0&id=4984819a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4984819a",
  null
  
)

export default component.exports